import { useMemo, useEffect, useState, useContext } from 'react';
import { FormLabel, Grid, Chip, Avatar, Tooltip } from '@material-ui/core';
import BreadCrumbs from '../../../../Core/Controls/Breadcrumb';
import ReportGijgoGrid from '../../ReportsScreens/GijgoForReportsScreen';
import { DatePicker, MultipleSelectWithMoreOp, SingelSelect, SelectBox } from '../../../../Core/FormInput';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import { GetTCardDashDropdowns, getTCardSchedules, getTCardSchedulesExcelFile } from '../../../../Core/Service/T-card-services';
import formatters from '../../../../Core/Grid/inputFormatter';
import ReactDOM from 'react-dom';
import LinkIcon from '@material-ui/icons/Link';
import EditIcon from '@material-ui/icons/Edit';

import DialogComp from '../../../../Core/Modal/dialogModal';
import { SquareButton } from '../../../../Core/FormInput/AppButton';
import ConfirmationModal from '../../../../Core/Controls/Dialog/ConfirmationModal';
import { postTCardsLocks_ResetLock_Save } from '../../../../Core/Service/checkInRole';
import AppContext from '../../../../App/AppContext';
import LockOpenIcon from '@material-ui/icons/LockOpen';

const baseColumns = [
    { field: 'action', sortable: false, title: `Action`, width: 120, filterable: false },
    { field: 'reg', sortable: true, title: `Reg No`, width: 120 },
    { field: 'bd', sortable: true, title: `Booking Date`, width: 180, renderer: formatters.DateFormatter },
    { field: 'cust', sortable: true, title: 'Customer' },
    { field: 'lockTime', sortable: true, title: 'Lock Time', width: 210 },
    { field: 'lockUser', sortable: true, title: 'Lock User', width: 210 }

    // { field: '', sortable: true, title: 'Last Done / KM', width: 120,
    //     renderer: function (value, record) {
    //     const formattedDate = formatters.DateTimeFormatter(record.lastDone);
    //     return `${formattedDate} ${record.lastDoneKM}`; }
];

const crumbs = () => {
    let list = [
        { name: 'Home', path: '/' },
        { name: 'T-Card', active: true },
        { name: 'Locked T-Cards', active: true }
    ];
    return list;
};

const useStyles = makeStyles((theme) => ({
    columnStyle: {
        cursor: 'pointer'
    }
}));

const LockedTCardListScreen = (props) => {
    const { showToast, showModal, portalSettings } = useContext(AppContext);

    const [state, setState] = useState({
        selectedRecord: {},
        showWarning: false,
        isReload: false
    });

    const editButton = (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container alignItems="center" justifyContent="center">
                <LockOpenIcon fontSize="small" color="secondary" onClick={() => handleEdit(record)} style={{ cursor: 'pointer' }} />
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const column = useMemo(() => {
        let col = [...baseColumns];
        let colAction = col.find((m) => m.field === 'action');

        if (colAction) {
            console.log('colAction', colAction);
            colAction.renderer = editButton;
        }

        return col;
    }, []);

    const handleEdit = (record) => {
        setState((st) => ({ ...st, showWarning: true, selectedRecord: record }));
    };
    const hideConfirmationModal = () => {
        setState((st) => ({ ...st, showWarning: false, selectedRecord: {} }));
    };
    const submitFunction = async () => {
        let res = await postTCardsLocks_ResetLock_Save(state.selectedRecord.tCardsLoackTCardID);
        if (res.success) {
            setState((st) => ({ ...st, isReload: new Date() }));
            showToast(res?.data?.message, 'success');
            hideConfirmationModal();
        }
    };

    const baseUrl = 'TCardLock/TCardsLocks_Get';
    return (
        <div className="report-screen-container">
            <BreadCrumbs crumbs={crumbs()} />
            <Grid container spacing={1} style={{ padding: '10px 0px' }}>
                <Grid item xs={12}>
                    <ReportGijgoGrid
                        dataConverter={(res) => ({
                            records: res.data.list,
                            records: res?.data?.list.map((p) => ({ ...p }))
                        })}
                        columns={column}
                        getUrl={baseUrl}
                        isReload={state.isReload}
                        isShowTotal={false}
                    />
                </Grid>
            </Grid>
            {state.showWarning ? (
                <DialogComp title="Warning" onClose={hideConfirmationModal} maxWidth="sm">
                    <ConfirmationModal
                        message={`Reset ${state.selectedRecord.reg} T-Card lock`}
                        handleSubmit={submitFunction}
                        handleCancel={hideConfirmationModal}
                        label="Unlock"
                    />
                </DialogComp>
            ) : null}
        </div>
    );
};
export default LockedTCardListScreen;
